// extracted by mini-css-extract-plugin
module.exports = {"lia-solved-badge":"MessageSolvedBadge_lia-solved-badge__BBnd1","lia-solved-icon":"MessageSolvedBadge_lia-solved-icon__vPi6y"};